import React from "react";

interface LoaderProps {
  size?: number;
  color?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  size = 24,
  color = "#3290B7",
}) => {
  return (
    <div
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: `2px solid rgba(50, 144, 183, 0.3)`,
        borderRadius: "50%",
        borderTopColor: color,
        animation: "spin 1s ease-in-out infinite",
      }}
    />
  );
};

// Добавляем CSS анимацию через style tag
const style = document.createElement("style");
style.textContent = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);

// Экспортируем новый LoadingSpinner
export {LoadingSpinner} from "./LoadingSpinner";
